<lib-menu
  [label]="lang.current.toUpperCase()"
  [a11yAltText]="['langSwitcher.alt.text'] | translate"
  [collapseOnMobile]="collapseOnMobile"
  [lightTheme]="lightTheme"
  [outlined]="true"
  [displayArrow]="false"
  [buttonClass]="`!border-[--color-border-primary] ${buttonClass()}`"
  [textClass]="textClass()"
>
  @for (lang of filteredLangs; track lang) {
    <lib-menu-item [menuItemLink]="getMenuItemLink(lang.value)">
      <span [class]="`font-bold text-[--color-text-primary]`" [attr.lang]="lang.value">{{ lang.label }}</span>
    </lib-menu-item>
  }
</lib-menu>
